export const getInitials = (name, lastname) => {
  if (!name) return '';
  const refinedName = name.replace(/[^a-zA-Z- ]/g, '');
  if (refinedName.length === 0) return '';

  if (lastname) {
    const refinedLastname = lastname.replace(/[^a-zA-Z- ]/g, '');
    if (refinedLastname.length === 0) return refinedName[0].toUpperCase();
    return refinedName[0].toUpperCase() + refinedLastname[0].toUpperCase();
  }
  const nameArray = refinedName.split(' ').filter((word) => word.length > 0);
  if (nameArray.length === 1) {
    return nameArray[0][0].toUpperCase();
  }
  return nameArray[0][0].toUpperCase() + nameArray[1][0].toUpperCase();
};
